import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import { getPostLoginPath, isExternalUser } from '../../utils/roleUtils';
import ExternalUserDashboard from './ExternalUserDashboard';
import InternalUserDashboard from './InternalUserDashboard';

// Import AdminDashboard if it exists
let AdminDashboard = null;
try {
  AdminDashboard = require('../Admin/AdminDashboard').default;
} catch (error) {
  console.log('AdminDashboard not found, using InternalUserDashboard as fallback');
}

const ConditionalDashboard = () => {
  const navigate = useNavigate();
  const { userData, loading } = useUser();

  useEffect(() => {
    if (!loading && isExternalUser(userData)) {
      navigate(getPostLoginPath(userData.roles), { replace: true });
    }
  }, [loading, userData, navigate]);

  const isAdminUser = () => {
    if (!userData || !userData.roles || userData.roles.length === 0) {
      return false;
    }

    const adminRoles = ['admin', 'super_admin'];
    return userData.roles.some(role => adminRoles.includes(role.toLowerCase()));
  };

  if (loading && !userData?.id) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <div>Loading dashboard...</div>
      </div>
    );
  }

  if (isExternalUser(userData)) {
    return null;
  }

  if (isAdminUser() && AdminDashboard) {
    return <AdminDashboard />;
  }

  return <InternalUserDashboard />;
};

export default ConditionalDashboard;
